module.exports = __webpack_public_path__ + "img/kirovograd_energo.f7ef6c68.jpg";